// src/FlightDataPage.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Button, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import NavBar from './NavBar'; // Correct import path

// Import the new components
import AccordionTabs from './components/flight-data/AccordionTabs';
import BreakdownArea from './components/flight-data/BreakdownArea';
import DispatchBoard from './components/flight-data/DispatchBoard';

function FlightDataPage() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // State for flight data and parameters
  const [tdrData, setTdrData] = useState(null);
  const [brockData, setBrockData] = useState(null);
  const [params, setParams] = useState({
    isPriorityFlight: false,
    hotThreshold: 30,
    coldThresholdHours: 3
  });
  const [inboundETA, setInboundETA] = useState('');

  // Load data from location state or localStorage
  useEffect(() => {
    if (location.state?.tdrData && location.state?.brockData) {
      // Data passed via navigation
      setTdrData(location.state.tdrData);
      setBrockData(location.state.brockData);
      
      // Load parameters if available
      if (location.state.breakdownParams) {
        setParams(location.state.breakdownParams);
      }
      
      // Extract and store the inbound ETA for reference
      if (location.state.tdrData?.inbound?.eta) {
        setInboundETA(location.state.tdrData.inbound.eta);
      }
    } else {
      // Try to load from localStorage
      const storedFlights = JSON.parse(localStorage.getItem('flightList') || '[]');
      if (storedFlights.length > 0) {
        const latestFlight = storedFlights[storedFlights.length - 1];
        setTdrData(latestFlight.tdrData);
        setBrockData(latestFlight.brockData);
        
        // Load parameters if available
        if (latestFlight.breakdownParams) {
          setParams(latestFlight.breakdownParams);
        }
        
        // Extract and store the inbound ETA
        if (latestFlight.tdrData?.inbound?.eta) {
          setInboundETA(latestFlight.tdrData.inbound.eta);
        }
      } else {
        // No data available, redirect to home
        navigate('/');
      }
    }
  }, [location.state, navigate]);

  // When parameters change
  useEffect(() => {
    console.log("Parameters updated:", params);
  }, [params]);

  // Navigate to home
  const handleHomeClick = () => {
    navigate('/');
  };

  // Check if we have data to display
  if (!tdrData || !brockData) {
    return (
      <Container>
        <h1>Loading flight data...</h1>
        <Button 
          variant="contained" 
          startIcon={<HomeIcon />}
          onClick={handleHomeClick}
          sx={{ mt: 2 }}
        >
          Return Home
        </Button>
      </Container>
    );
  }

  return (
    <>
      {/* Add the NavBar */}
      <NavBar />
      
      {/* Spacer to account for the fixed navbar */}
      <Box sx={{ height: 84 }} />
      
      {/* Standard container for header and other components */}
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <h1>Flight Data Analysis</h1>
          <Button 
            variant="contained" 
            startIcon={<HomeIcon />}
            onClick={handleHomeClick}
            sx={{
              backgroundColor: '#333',
              '&:hover': {
                backgroundColor: '#555',
              },
            }}
          >
            Return Home
          </Button>
        </Box>

        {/* New Accordion Tabs Component */}
        <AccordionTabs 
          tdrData={tdrData} 
          brockData={brockData}
          params={params}
          inboundETA={inboundETA}
        />

        {/* New Breakdown Area */}
        <BreakdownArea 
          tdrData={tdrData}
          brockData={brockData}
          inboundETA={inboundETA}
        />
      </Container>

      {/* Full-width dispatch board outside the container */}
      <Box sx={{ width: '100%'}}>
        <DispatchBoard
          tdrData={tdrData}
          brockData={brockData}
          params={params}
          inboundETA={inboundETA}
        />
      </Box>
    </>
  );
}

export default FlightDataPage;